export const CONSECUTIVE_SPACE_ATTEMPT_WARNING_THRESHOLD = 3;

// This is based on the width of the drop shape of the add toolbar plus some
// arbitrary padding to make it look 'right'.
export const ADD_TOOLBAR_TOGGLE_WIDTH = 40;

export const SHORTCUTS = Object.freeze({
  BOLD: 'bold',
  ITALIC: 'italic',
  BR: 'br',
  NBSP: 'nbsp',
  RIGHT_ARROW: 'right_arrow',
  UL: 'ul',
  OL: 'ol',
  LINK: 'link',
  CUT: 'cut',
  COPY: 'copy',
  PASTE: 'paste',
  UNDO: 'undo',
  REDO: 'redo',
  STOP_EDITING: 'stop_editing',
  SELECT_ALL: 'select_all',
  UNDERLINE: 'underline',
  //Underline is going to implemented soon. Laying down the ground work
  //while adding listeners to block the action until it is functional.
  BLOCKQUOTE: 'blockquote',
  HEADING: 'heading',
  INDENT: 'indent',
  OUTDENT: 'outdent',
  NUMBER_INCREMENT: 'number_increment',
  NUMBER_DECREMENT: 'number_decrement',
  NUMBER_INCREMENT_BY_TEN: 'number_increment_by_ten',
  NUMBER_DECREMENT_BY_TEN: 'number_decrement_by_ten',
});

export const TOOLBARS = Object.freeze({
  __LEGACY__ADD: 'add' as const,
  LIST: 'list' as const,
  LINK: 'link' as const,
  FORMAT: 'format' as const,
  FIGURE: 'figure' as const,
  FIGURESETTINGS: 'figureSettings' as const,
  MEDIA: 'media' as const,
  CUSTOMCLASS: 'customclass' as const,
  EMBED: 'embed' as const,
  CODEBLOCK: 'codeBlock' as const,
  CODEBLOCKSETTINGS: 'codeBlockSettings' as const,
  AI_ONLY: 'aiOnly' as const,
  COMPONENT: 'component' as const,
  COMPONENTSETTINGS: 'componentSettings' as const,
});

export const TOOLBAR_BUTTONS = Object.freeze({
  bold: 'bold',
  italic: 'italic',
  link: 'link',
  span: 'span',
  superscript: 'superscript',
  subscript: 'subscript',
  clear: 'clear',
  ol: 'ol',
  ul: 'ul',
  inlineCode: 'inlineCode',
});

export const FIGURE_ALIGNMENT_MAP = Object.freeze({
  'figure-position-center': 'center',
  'figure-position-fullwidth': 'fullwidth',
  'figure-position-normal': 'normal',
  'figure-position-floatleft': 'floatleft',
  'figure-position-floatright': 'floatright',
});

export const ANCHOR_TYPES = Object.freeze([
  'external',
  'page',
  'section',
  'email',
  'tel',
]);
export const DYN_ANCHOR_TYPES_MAP = Object.freeze({
  external: 'external',
  email: 'email',
  tel: 'tel',
  section: 'section',
  page: 'page',
});

// Anchor types supported for hrefs dyn-bound to link field (with prefixing)
export const DYN_HREF_ANCHOR_TYPES = Object.freeze([
  'external',
  'email',
  'tel',
]);
// Note: we don't show section link options in the data manager (applies to rich text fields)
// But dyn-bound rich text fields on page, ie: cms-canvas will get section options
export const DYN_FIELD_ANCHOR_TYPES = Object.freeze([
  'external',
  'page',
  'email',
  'tel',
]);

export const ANCHOR_PLACEHOLDERS = Object.freeze({
  external: 'http://www.example.com/',
  page: 'Select a page...',
  section: 'Select a page section...',
  email: 'email@address.com',
  tel: '+1-800-555-1234',
});

export const TOOLBAR_ALIGNMENT_POSITION_MAP = Object.freeze({
  [TOOLBARS.__LEGACY__ADD]: 'right',
  [TOOLBARS.LIST]: 'right',
  [TOOLBARS.EMBED]: 'top',
  [TOOLBARS.LINK]: 'top',
  [TOOLBARS.FORMAT]: 'top',
  [TOOLBARS.AI_ONLY]: 'top',
  [TOOLBARS.FIGURE]: 'top',
  [TOOLBARS.MEDIA]: 'right',
  [TOOLBARS.FIGURESETTINGS]: 'top',
  [TOOLBARS.CODEBLOCK]: 'top',
  [TOOLBARS.COMPONENT]: 'top',
  [TOOLBARS.COMPONENTSETTINGS]: 'top',
  addPlusButton: 'left',
  aiEditMenu: 'top',
  aiPromptMenu: 'top',
  aiLoadingBar: 'top',
});

export const PASTE_SELECTION_MARKER = '\u262f';

// Part of the fluid aspect ratio mechanism where width/maxWidth is the figure's width as a
// percentage of the rich text field/node's width, and the padding-bottom (for videos/iframes)
// is a percentage of the figure's width.
// The default width is 60% and the default aspect ratio 16:9 so the 'height' is
// ie: 9/16*60 === 33.75%
export const DEFAULT_VIDEO_PADDING_BOTTOM = '33.75%';

export const EDIT_STYLES = Object.freeze({
  // Note: Browsers typically modify the wordbreak behavior of elements with
  // contenteditable=true so that the text you're editing doesn't run off the
  // page. This whitespace hack is in the same vein and borrowed from
  // Draft.js, it allows the caret to move 'around' a space at the end of a
  // node. Otherwise the space will appear visually not to exist, and
  // sometimes be inserted to the right of the caret. Alternative hacks that
  // require adding/removing NBSP/ZWJ characters are unpredictable, and
  // increase the complexity of the code in order to juggle those ephemeral
  // spaces.
  whiteSpace: 'pre-wrap',
});

// This is mainly consumed by the rich text stuff so is here. Temporary as
// We're both planning on removing Bem, and merging the Editor into the Designer
export const CMS_CLASS_PREFIX = 'w-editor-';
